import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const TaxCalculatorIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M39.2 49.4H10.8c-2.8 0-5-2.2-5-5v-38c0-2.8 2.2-5 5-5h28.4c2.8 0 5 2.2 5 5v38c0 2.7-2.2 5-5 5z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M38.8 14.2H11.6c-.3 0-.5-.2-.5-.5V7.9c0-.3.2-.5.5-.5h27.2c.3 0 .5.2.5.5v5.8c0 .3-.2.5-.5.5z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M10.6 24.2h4.8V29h-4.8zM18.6 24.2h4.8V29h-4.8zM26.7 24.2h4.8V29h-4.8zM34.6 24.2h4.8V29h-4.8zM10.6 31.4h4.8v4.8h-4.8zM18.6 31.4h4.8v4.8h-4.8zM26.7 31.4h4.8v4.8h-4.8zM10.6 38.6h4.8v4.8h-4.8zM18.6 38.6h4.8v4.8h-4.8zM26.7 38.6h4.8v4.8h-4.8zM34.6 31.4h4.8v12h-4.8z"
        fill="#E81C30"
        className={styles.accentColor}
      />
      <path
        d="M10.6 19.2h28.8"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeDasharray="1,2"
        strokeMiterlimit="10"
      />
    </Icon>
  )
}
